import { EliteAgencyTeamsPage } from './index'

import { RouteFactory } from './../../shared/router/Route.factory'
import { RequiresAuthGuard, RequiresUsertypesGuard } from './../../shared/router/guards'

export default [
  RouteFactory.create(
    EliteAgencyTeamsPage,
    '/elite-agency-teams',
    [
      new RequiresAuthGuard(true),
      new RequiresUsertypesGuard(['agency-owner', 'internal-admin', 'internal-staff', 'system-admin']),
    ],
    {
      name: 'Elite Agency Teams',
    }
  ),
]
